import { Provider } from '@angular/core';
import { ChatDataHttpService } from './abstract';
import { ChatDataHttpServiceImpl } from './chat-data-http.service';

export const ChatDataHttpProvider: Provider = {
	provide: ChatDataHttpService,
	useClass: ChatDataHttpServiceImpl,
};
